module.exports = __webpack_public_path__ + "static/img/156_TO8_1879_og.38088da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/156_TO8_1879_og.jpg
// module id = kjt8
// module chunks = 0